import { useErrorContext } from '../../context/ErrorContext';
import MidAddSuppliers from '../../middleware/Supplier/MidAddSuppliers';
import { useState, ToastContainer, overlayStyle, loaderStyle, useParams, FaTrash, FaCartPlus, DataTable, useMemo, FaRupeeSign, MdErrorOutline, FaArrowAltCircleRight, noDatapng } from '../../common/common';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Button from 'react-bootstrap/Button';
import { Modal } from 'react-bootstrap';
import { stripHtmlTags } from '../../common/CommonFunctions';

import MidSuppliersProducts from '../../middleware/Supplier/MidSuppliersProducts';
import { useEffect } from 'react';
import { showToast } from '../../Utils/toastUtils';

const SuppliersProducts = () => {
    const params = useParams();
    const type = params.type || 'buyer';
    const supplier_id = params.supplierID || 'default_value';
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const { error } = useErrorContext();
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, isLoading, products, fullscreen, setFullscreen, cart, dispatch, addressData, setAddressData, totalitem, total, modalShow, setModalshow, handleshowaddressmodal, handlehideaddressmodal, handleAddressModalSubmit, addvalues, handleaddressChange, handleChange, handlenameChange, handleSubmit } = MidSuppliersProducts(supplier_id, type);
    // const [hideDirector, setHideDirector] = useState(true);
    const [cartmodal, setCartModal] = useState(false);

    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var CompanyName = users[0]['CompanyName'];
        var userAddress1 = users[0]['Address1'];
        var userAddress2 = users[0]['Address2'];
        var Mobile = users[0]['Mobile'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
    }
    
    const MainColumns = useMemo(
        () => [{
            name: "Photo",
            style: {
                color: 'black ',
                fontSize: '14px',
                fontWeight: '500',
                maxWidth: '250px', // Set max width for Name column
            },
            selector: (row) => <img className="p-2 rounded-xl" width={70} height={70} src={`${process.env.REACT_APP_API_URL}/api/products/uploads/${row.product_variant_image}`} />,
        },
        {
            name: "Code",

            style: {
                color: 'black ',
                fontSize: '14px',
                fontWeight: '500',
                maxWidth: '250px', // Set max width for Name column
            },
            selector: (row) => row.Product_code,
        },
        {
            name: "Name",

            style: {
                color: 'black ',
                fontSize: '14px',
                fontWeight: '500',
                maxWidth: '250px', // Set max width for Name column
            },
            selector: (row) => row.product_name,
        },

        // {
        //     name: "Short Description",
        //     style: {
        //         color: 'black ',
        //         fontSize: '14px',
        //         fontWeight: '500',
        //         maxWidth: '250px', // Set max width for Name column
        //     },
        //     sortable: true,
        //     omit: hideDirector,
        //     wrap: true,
        //     selector: (row) => stripHtmlTags(row.product_short_description),
        // },
        {
            name: "Category",
            style: {
                color: 'black ',
                fontSize: '14px',
                fontWeight: '500',
                maxWidth: '250px', // Set max width for Name column

            },
            sortable: true,
            selector: (row) => row.category_name,
        },
        {
            name: "Variant",
            style: {
                color: 'black ',
                fontSize: '14px',
                fontWeight: '500',
                maxWidth: '250px', // Set max width for Name column

            },
            sortable: true,
            selector: (row) => row.product_variant,
        },
        {
            name: "Shippining Pack",
            style: {
                color: 'black ',
                fontSize: '14px',
                fontWeight: '500',
                maxWidth: '250px', // Set max width for Name column

            },
            sortable: true,
            selector: (row) => row.selling_unit_packing_type,
        },
        {
            name: "Price",
            style: {
                color: 'black ',
                fontSize: '14px',
                fontWeight: '500',
                maxWidth: '250px', // Set max width for Name column

            },
            sortable: true,
            selector: (row) => row.priceDetails?.price || row.product_price,
        },
        // {
        //     name: "Action",
        //     selector: (row) => <div className='flex flex-row '>
        //         {cart.some((p) => p.id === row.id) ? <button className='btn btn-danger btn-sm mx-1 flex flex-row ' onClick={() => { dispatch({ type: "REMOVE_FROM_CART", payload: row }) }}>Remove From Cart </button> : <button className='btn btn-primary btn-sm mx-1 flex flex-row ' onClick={() => { dispatch({ type: "ADD_TO_CART", payload: row }) }} >Add To Cart </button>}
        //     </div>,
        // },
        {
  name: "Action",
  selector: (row) => (
    <div className="flex flex-row">
      {row.is_available === 0 ? (
        <button
          className="btn btn-secondary btn-sm mx-1"
          disabled
        >
          Unavailable
        </button>
      ) : cart.some((p) => p.id === row.id) ? (
        <button
          className="btn btn-danger btn-sm mx-1"
          onClick={() =>
            dispatch({ type: "REMOVE_FROM_CART", payload: row })
          }
        >
          Remove From Cart
        </button>
      ) : (
        <button
          className="btn btn-primary btn-sm mx-1"
          onClick={() =>
            dispatch({ type: "ADD_TO_CART", payload: row })
          }
        >
          Add To Cart
        </button>
      )}
    </div>
  ),
}

        ],
        [cart],
        // [hideDirector, cart],
    );


    // console.log({cart:cart});
    

    // const [totalOrders, setTotalOrders] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const calculateTax = (shippingUnit, productPrice, qty, taxRate) => {
        return (shippingUnit * productPrice * qty * taxRate) / 100;
    };

    const calculateTotal = (shippingUnit, productPrice, qty, taxRate) => {
        const subtotal = shippingUnit * productPrice * qty;
        const tax = calculateTax(shippingUnit, productPrice, qty, taxRate);
        const updatedData = subtotal + tax;
        return updatedData;
    };
    useEffect(() => {
        let total = 0;

        // Assuming `data` is your list of rows (products in the cart)
        cart.forEach(row => {
            const rowTotal = calculateTotal(row.shipping_unit, (row?.priceDetails?.price || row.product_price), row.qty, row.tax);
            total += rowTotal;
        });

        setTotalAmount(total);
    }, [cart]); // Recalculate whenever `data` changes

    const columns = [
        {
            name: "Image",
            selector: (row) => (
                <img src={`${process.env.REACT_APP_API_URL}/api/products/uploads/${row.product_variant_image}`} alt={row.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
            ),
        },
        {
            name: "Product ID",
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.product_id,
        },
        {
            name: "Name",
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.product_name,
        },
        {
            name: "Variant",
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.product_variant,
        },
        {
            name: "Quantity",
            align: 'center',
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => (
                <div align='center' className="relative">
                    <button
                        type="button"
                        className="absolute bg-[#135bdf] text-white rounded-full h-6 w-6 mx-1 my-1"
                        onClick={() => {
                            dispatch({ type: "DECREMENT_FROM_CART", payload: row });
                        }}
                    >
                        -
                    </button>

                    <input
                        className="bg-gray-200 p-1 text-md focus:outline-none text-[#135bdf] h-8 w-full text-center rounded-xl text-lg font-bold"
                        type="text"
                        name="product_qty"
                        id="product_qty"
                        autoComplete="new-password"
                        value={row.qty || 0} // Ensure that qty is never undefined, use 0 if undefined
                        onKeyUp={(e) => {
                            const qty = e.target.value.trim() === "" || isNaN(e.target.value) ? 0 : Number(e.target.value);
                            dispatch({
                                type: "HANDLE_KEY_UP_QTY",
                                payload: { id: row.id, qty },
                            });
                        }}
                        onChange={(e) => {
                            const qty = e.target.value.trim() === "" || isNaN(e.target.value) ? 0 : Number(e.target.value);
                            dispatch({
                                type: "HANDLE_QTY",
                                payload: { id: row.id, qty },
                            });
                        }}
                    />

                    <button
                        type="button"
                        className="absolute bg-[#135bdf] text-white rounded-full h-6 w-6 right-0 my-1"
                        onClick={() => {
                            dispatch({ type: "INCREMENT_TO_CART", payload: row });
                        }}
                    >
                        +
                    </button>
                </div>
            ),
        },
        {
            name: "Shipping Pack",
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.shipping_unit_packing_type,
        },
        {
            name: "Shipping Units",
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.shipping_unit,
        },
        {
            name: "selling Unit Packing",
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.selling_unit_packing_type,
        },

        {
            name: "Price (In Rupees)",
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => `₹${row?.priceDetails?.price || row.product_price}`,
        },

        {
            name: "Sub Total",
            align: 'center',
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => `₹${row.shipping_unit * (row?.priceDetails?.price || row.product_price) * row.qty}`,
        },
        {
            name: "Tax/GST",
            align: 'center',
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => {
                const taxAmount = calculateTax(row.shipping_unit, (row?.priceDetails?.price || row.product_price), row.qty, row.tax);
                return `₹${taxAmount}`;
            },
            // selector: (row) => `₹${((row.shipping_unit * row.product_price * row.qty) * (row.tax)) / 100}`,
        },
        {
            name: "Total",
            align: 'center',
            style: {
                color: 'black',
                fontSize: '14px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => {
                const totalAmount = calculateTotal(row.shipping_unit, (row?.priceDetails?.price || row.product_price), row.qty, row.tax);
                return `₹${totalAmount}`;
            },
            // selector: (row) => `₹${((row.shipping_unit * row.product_price * row.qty) + ((row.shipping_unit * row.product_price * row.qty) * (row.tax)) / 100)}`,
        },
        {
            name: "Action",
            selector: (row) => (
                <div className="flex flex-row">
                    <button
                        className="bg-red-100 p-3 rounded-full cursor-pointer"
                        onClick={() => {
                            dispatch({ type: "REMOVE_FROM_CART", payload: row });

                            setTimeout(() => {
                                if (cart.length === 1) {
                                    handlemodalhide(); // cart will become empty after this dispatch
                                }
                            }, 0);
                        }}
                    >
                        <FaTrash className="text-red-700" />
                    </button>
                </div>
            ),
        }

    ];

    const handlemodalshow = () => {
        setCartModal(true);
    }
    const handlemodalhide = () => {
        setCartModal(false);
    }
    const handlenavigatetocart = () => {
        //navigate("/buyer/supplier/Cart/");

        if (cart.length > 0) {
            handlemodalshow();
        }
        else {
            showToast("Select Product To Cart !!!", 'error')
        }
    }
    const groupedCart = cart.reduce((acc, item) => {
        const supplierId = item.user_id; // ya jaisa bhi supplier id ka key ho aapke cart item me
        if (!acc[supplierId]) acc[supplierId] = [];
        acc[supplierId].push(item);
        return acc;
    }, {});

    const totalOrders = useMemo(() => {
        const suppliersWithQty = new Set(cart.filter(item => (item.qty || 1) > 0).map(item => item.user_id));
        return suppliersWithQty.size;
    }, [cart]);

    const supplierCount = useMemo(() => new Set(cart.map(item => item.user_id)).size, [cart]);


    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="grid grid-cols-12">
                    <div className="col-start-1 col-end-13">
                        <div className=" p-4 text-xl  text-[#1e3a8a]  ">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'> Supplier Products</h1>
                                <p className=' text-gray-600 text-[16px] '>Browse and access essential product details curated by suppliers for quick and informed purchasing decisions.</p>
                            </div>
                        </div>
                        <div className="border-0 flex-row rounded-xl m-3 p-4 bg-white shadow-xs">
                            <div className=' relative flex flex-col min-w-0 break-words'>
                                <div className='p-3'>
                                    <div className="flex flex-row justify-between">
                                        <div className='flex flex-row justify-between items-center mb-4'>
                                            <h5 className=" capitalize text-xl font-bold mb-0">Products</h5>
                                        </div>
                                        <div className="flex flex-row justify-end">
                                            {/* <button className='rounded-md group px-3  flex space-x-2 items-center bg-[#196ef9] text-white font-semibold  w-[320px]' onClick={() => setHideDirector(!hideDirector)}>Hide Product Short Description Column</button> */}
                                            <button type="submit" className="relative rounded-md group px-3 mx-3 h-12  flex space-x-2 items-center bg-[#196ef9]  w-[150px]" onClick={handlenavigatetocart}>
                                                <div className="flex items-center h-12 w-12 rounded-full absolute right-[0px] z-20 drop-shadow-2xl ">
                                                    <FaCartPlus className="h-4 w-4 text-white translate-x-4 transition duration-300 " />
                                                </div>
                                                <span className="relative text-md text-white font-semibold pl-0">View Cart</span>
                                                <p className='absolute -top-5 -right-5 text-white rounded-full bg-green-600 w-10 h-10 p-2 z-20'>{cart.length}</p>
                                            </button>
                                        </div>
                                    </div>
                                    <DataTable
                                        columns={MainColumns}
                                        data={products}
                                        pagination
                                        responsive
                                        highlightOnHover
                                        customStyles={{
                                            headCells: { style: { maxWidth: '250px !important' }, },
                                        }}
                                    />

                                    <Modal
                                        size="xl"
                                        fullscreen={fullscreen}
                                        dialogClassName="modal-90w"
                                        show={cartmodal}
                                        onHide={handlemodalhide}
                                        aria-labelledby="example-modal-sizes-title-lg"
                                    >
                                        <form method="POST" onSubmit={(e) => e.preventDefault()}>
                                            <Modal.Body className="bg-[#f2f2f2]">
                                                <div className="relative border-b border-slate-200/60 py-3">
                                                    <label className="text-lg">Confirm Order</label>
                                                    <div
                                                        className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer"
                                                        onClick={handlemodalhide}
                                                    >
                                                        ESC / Close
                                                    </div>
                                                </div>

                                                <div className="flex flex-col space-y-6">
                                                    {/* Supplier wise grouped cart */}
                                                    {Object.entries(groupedCart).map(([supplierId, items]) => (
                                                        <div key={supplierId} className="bg-white p-4 rounded-md shadow-md">
                                                            <h3 className="text-xl font-semibold mb-4">Supplier ID: {supplierId}</h3>
                                                            <DataTable
                                                                columns={columns}
                                                                data={items}
                                                                responsive
                                                                highlightOnHover
                                                                customStyles={{
                                                                    headCells: { style: { maxWidth: '250px !important' } },
                                                                }}
                                                            />
                                                        </div>
                                                    ))}

                                                    {/* Summary */}
                                                    {/* <div className="w-full mx-3 rounded-md my-2 bg-white p-4">
                                                        <h2 className="text-lg font-semibold mb-4">Summary</h2>
                                                        <table className="min-w-full table-auto">
                                                            <tbody>
                                                                <tr className="border-b">
                                                                    <td className="px-4 py-2 font-medium">Total Items</td>
                                                                    <td className="px-4 py-2 text-lg font-bold">{totalitem}</td>
                                                                </tr>
                                                                <tr className="border-b">
                                                                    <td className="px-4 py-2 font-medium">Total Amount</td>
                                                                    <td className="px-4 py-2 text-lg font-bold flex items-center">
                                                                        <FaRupeeSign className="text-md inline mr-1" />
                                                                        {totalAmount?.toFixed(2)}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div> */}
                                                    <div className="flex justify-end">
                                                        <div className="w-[30%] bg-white p-4 rounded-md shadow-md float-right">
                                                            <h2 className="text-lg font-semibold mb-4">Summary</h2>
                                                            <table className="min-w-full table-auto">
                                                                <tbody>
                                                                    <tr className="border-b">
                                                                        <td className="px-4 py-2 font-medium">Total Items</td>
                                                                        <td className="px-4 py-2 text-lg font-bold">{totalitem}</td>
                                                                    </tr>
                                                                    <tr className="border-b">
                                                                        <td className="px-4 py-2 font-medium">Total Amount</td>
                                                                        <td className="px-4 py-2 text-lg font-bold flex items-center">
                                                                            <FaRupeeSign className="text-md inline mr-1" />
                                                                            {totalAmount?.toFixed(2)}
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="border-b">
                                                                        <td className="px-4 py-2 font-medium">Total Orders</td>
                                                                        <td className="px-4 py-2 text-lg font-bold">{totalOrders}</td>
                                                                    </tr>
                                                                    <tr className="border-b">
                                                                        <td className="px-4 py-2 font-medium">Supplier Count</td>
                                                                        <td className="px-4 py-2 text-lg font-bold">{supplierCount}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>



                                                    {/* Delivery Address and Transport Details */}
                                                    <div className="w-full flex space-x-4">
                                                        <div className="priority p-3 bg-white w-[60%] rounded-md shadow-sm">
                                                            <div className="flex items-center justify-between mb-4">
                                                                <h1 className="text-md text-gray-600 font-semibold">Delivery Address</h1>
                                                                <Button
                                                                    className="bg-[#0d6efd] mx-2"
                                                                    variant="primary"
                                                                    size="sm"
                                                                    onClick={handleshowaddressmodal}
                                                                >
                                                                    Add New Address
                                                                </Button>
                                                            </div>

                                                            <Modal
                                                                size="md"
                                                                show={modalShow}
                                                                onHide={handlehideaddressmodal}
                                                                aria-labelledby="example-modal-sizes-title-lg"
                                                            >
                                                                <Modal.Body>
                                                                    <div className="relative border-b border-slate-200/60 py-2">
                                                                        <label className="text-lg">Add New Address</label>
                                                                        <div
                                                                            className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer"
                                                                            onClick={handlehideaddressmodal}
                                                                        >
                                                                            ESC
                                                                        </div>
                                                                    </div>
                                                                    <div className="p-2">
                                                                        <form method="POST" onSubmit={handleAddressModalSubmit}>
                                                                            <div className="grid grid-cols-1 gap-4">
                                                                                <div>
                                                                                    <label className="block my-3">
                                                                                        <span className="block text-sm font-medium text-slate-700">
                                                                                            Address Title
                                                                                        </span>
                                                                                    </label>
                                                                                    <div className="bg-transparent mb-1 flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                                                                        <input
                                                                                            className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6"
                                                                                            type="text"
                                                                                            name="addressTitle"
                                                                                            id="addressTitle"
                                                                                            placeholder="Enter address title"
                                                                                            autoComplete="new-password"
                                                                                            value={addvalues.addressTitle}
                                                                                            onChange={handleaddressChange}
                                                                                        />
                                                                                        {error.addressTitle && (
                                                                                            <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                                                        )}
                                                                                    </div>
                                                                                    {error.addressTitle && (
                                                                                        <p className="my-2 px-2 text-red-600 text-xs">{error.addressTitle}</p>
                                                                                    )}
                                                                                </div>
                                                                                <div>
                                                                                    <label className="block my-3">
                                                                                        <span className="block text-sm font-medium text-slate-700">Address</span>
                                                                                    </label>
                                                                                    <div className="bg-transparent mb-1 flex relative border-[1px] border-solid border-[#c5c5c5] p-2 rounded-md">
                                                                                        <textarea
                                                                                            className="w-full"
                                                                                            rows="8"
                                                                                            name="address"
                                                                                            id="address"
                                                                                            placeholder="Enter Address"
                                                                                            value={addvalues.address}
                                                                                            onChange={handleaddressChange}
                                                                                        ></textarea>
                                                                                        {error.address && (
                                                                                            <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                                                        )}
                                                                                    </div>
                                                                                    {error.address && (
                                                                                        <p className="my-2 px-2 text-red-600 text-xs">{error.address}</p>
                                                                                    )}
                                                                                </div>
                                                                                <div className="flex justify-end">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="relative rounded-md group px-3 h-12 mt-2 ml-2 flex space-x-2 items-center bg-button-color hover:bg-button-color w-[150px]"
                                                                                        onClick={handleAddressModalSubmit}
                                                                                    >
                                                                                        <span className="relative text-md text-black font-semibold pl-3">
                                                                                            Submit
                                                                                        </span>
                                                                                        <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-[0px] z-20 drop-shadow-2xl ">
                                                                                            <FaArrowAltCircleRight className="h-3 w-3 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                                                                        </div>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                    </div>
                                                                </Modal.Body>
                                                            </Modal>

                                                            <div className="mx-auto">
                                                                {addressData.length > 0 ? (
                                                                    <div className="grid grid-cols-1 relative">
                                                                        {addressData.map((item) => (
                                                                            <div
                                                                                key={item.id}
                                                                                className="bg-gray-100 rounded-md shadow-sm relative p-2 my-2 flex items-center space-x-3"
                                                                            >
                                                                                <input type="radio" name="address" value={item.id} onChange={handleChange} />
                                                                                <div>
                                                                                    <label className="font-bold text-gray-800 text-md m-3">
                                                                                        {item.AddressTitle}
                                                                                    </label>
                                                                                    <p className="text-gray-500 text-md font-medium ml-3">
                                                                                        {item.Address} (ID: {item.id})
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                ) : (
                                                                    <center>
                                                                        <img
                                                                            src={noDatapng}
                                                                            height={260}
                                                                            width={260}
                                                                            className="opacity-50"
                                                                            alt="No Data"
                                                                        />
                                                                        <h1 className="text-md -translate-y-10 text-gray-300 font-bold">
                                                                            Opps ! No Data Found
                                                                        </h1>
                                                                    </center>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="priority bg-white p-2 m-2 w-[40%] rounded-md shadow-sm">
                                                            <h1 className="text-md text-gray-800 font-bold px-3 py-2">Transport Details</h1>
                                                            <div className="mx-auto">
                                                                <textarea
                                                                    rows="3"
                                                                    id="custommsg"
                                                                    name="custommsg"
                                                                    className="w-full border-2 border-solid border-gray-400 rounded-md mx-3"
                                                                    onChange={handlenameChange}
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="w-full p-3">
                                                        <div className="flex flex-row justify-end space-x-4 items-center">
                                                            <p className="text-sm font-semibold text-gray-400 p-3 max-w-[60%]">
                                                                By clicking Place order, you agree to the Selzor{' '}
                                                                <a
                                                                    href="https://www.atlassian.com/legal/cloud-terms-of-service"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="underline"
                                                                >
                                                                    Cloud Terms of Service
                                                                </a>{' '}
                                                                and{' '}
                                                                <a
                                                                    href="https://www.atlassian.com/legal/privacy-policy"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="underline"
                                                                >
                                                                    Privacy Policy For our services
                                                                </a>
                                                                .
                                                            </p>

                                                            <button
                                                                type="button"
                                                                className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5"
                                                                onClick={handlemodalhide}
                                                            >
                                                                Close
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5"
                                                                onClick={handleSubmit}
                                                            >
                                                                Place Order
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Modal.Body>
                                        </form>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}

export default SuppliersProducts